import { COLORS, Col, FlexView, Row } from '@cuemath/comps';
import { Button, Image, Separator, Text, TextInput } from '@cuemath/web-comps';
import React from 'react';
import styled from 'styled-components';
import useLogic from './logic';
import { getFormattedDate } from 'utils';
import ClockRed from 'img/clock-red.svg';

const InputWrapper = styled(FlexView)`
  width: 160px;
  height: 44px;
`;
const Icon = styled(Image)`
  margin-right: 4px;
`;

const BookTrialClassModal = ({
  teacherName,
  teacherID,
  timezone,
  prospectID,
  selectedDate,
  inputTime,
}) => {
  const {
    time,
    handleChange,
    error,
    isSubmitDisabled,
    handleBookTrialClass,
    isBookTrialClassProcessing,
    buttonLabel,
  } = useLogic({
    teacherID,
    timezone,
    prospectID,
    selectedDate,
    inputTime,
  });

  const detailItem = (label, value) => (
    <FlexView>
      <Text variant="eyebrow2" color={COLORS.COLA_LIGHTER}>
        {label}
      </Text>
      <Separator height={4} />
      <Text variant="h6">{value}</Text>
    </FlexView>
  );

  const formattedDate = getFormattedDate(selectedDate, "dddd, DD MMMM 'YY");

  return (
    <FlexView gap={24} gutter={24}>
      <Text variant="h4">Scheduling the 55 minutes trial class</Text>
      <Separator height={24} />
      <Row>
        <Col gutter={0}>{detailItem('teacher', teacherName)}</Col>
        <Col gutter={32}></Col>
        <Col gutter={0}>{detailItem('Date selected', formattedDate)}</Col>
      </Row>
      <Separator height={24} />
      <InputWrapper>
        <TextInput
          type="time"
          label="Start time"
          value={time}
          onChange={value => handleChange(value)}
        />
      </InputWrapper>
      {error && (
        <>
          <Separator height={8} />
          <FlexView flexDirection="row" alignItems="center">
            <Icon height={24} width={24} url={ClockRed} />
            <Text variant="body2" color={COLORS.RED_SHADE}>
              {error}
            </Text>
          </FlexView>
        </>
      )}
      <Separator height={24} />
      <Button
        label={buttonLabel}
        onClick={handleBookTrialClass}
        isDisabled={isSubmitDisabled}
        width="100%"
        isBusy={isBookTrialClassProcessing}
      />
    </FlexView>
  );
};

export default BookTrialClassModal;
